import React, { FC, MouseEventHandler, useCallback, useState } from 'react';
import { getSelectedOrganization } from '@client/store/organization';
import { Alert, Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { IconButton } from '@ui/buttons';

const GFAQuotaExceededAlert: FC = () => {
  const { classes } = useStyles();
  const selectedOrganization = getSelectedOrganization();
  const [isClosed, setIsClosed] = useState(false);

  const handleClose: MouseEventHandler<HTMLButtonElement> = useCallback(
    (event) => {
      event.stopPropagation();
      setIsClosed(!isClosed);
    },
    [isClosed],
  );

  return (
    <Alert
      severity="warning"
      variant="standard"
      sx={{ display: isClosed ? 'none' : 'flex' }}
      classes={{
        action: classes.actionWrapperElement,
        root: classes.alertRoot,
      }}
      action={<IconButton category="mui" icon="Close" onClick={handleClose} />}
    >
      <Box>
        You have exceeded {selectedOrganization}&apos;s current Gross Floor Area
        Quota.{' '}
        <a
          href="mailto:alexander@nodon.se?subject=We would like to extend our GFA quota"
          style={{ color: '#623e1c' }}
        >
          Contact us to extend your quota.
        </a>
      </Box>
    </Alert>
  );
};

const useStyles = makeStyles()(({ spacing }) => ({
  actionWrapperElement: {
    position: 'absolute',
    right: 0,
    top: 0,
    margin: 0,
    padding: spacing(1),
  },
  alertRoot: {
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f7d1aa',
    position: 'relative',
  },
}));

export default GFAQuotaExceededAlert;
